import { useState } from "react";
import * as v from "valibot";
import { valibotResolver } from "@hookform/resolvers/valibot";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { Input } from "../../common/input/Input";
import { CustomToast } from "../../common/customToast/CustomToast";
import { Select } from "../../common/select/Select";
import { useSignUpMutation } from "../../../features/api/user/userApi";
import { Roles } from "../../../customHooks/roleChecker/roles";

let roles = Object.values(Roles);

const schema = v.object({
  role: v.union(
    [v.literal("ADMIN"), v.literal("MANAGER"), v.literal("SALES_EXECUTIVE")],
    "User role is required"
  ),
  firstName: v.pipe(
    v.string("First name is required"),
    v.minLength(3, "At least 3 letters is required")
  ),
  lastName: v.pipe(
    v.string("Last name is required"),
    v.minLength(3, "At least 3 letters is required")
  ),
  phone: v.pipe(
    v.string("Phone number is required"),
    v.minLength(10, "At least 10 digits is required")
  ),
  email: v.pipe(
    v.email("Email is required"),
    v.minLength(5, "Correct email format is required")
  ),
});

export const AddUser = ({ onSuccess }) => {
  const [user, setUser] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    role: "",
  });
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: user,
    resolver: valibotResolver(schema),
  });
  // const [addCategory, { isLoading, isSuccess, isError, error }] =
  //   useAddCategoryMutation()
  const [registerUser, { isLoading, isSuccess, isError, error }] =
    useSignUpMutation();
  const onSubmit = async (data) => {
    try {
      let res = await registerUser(data).unwrap();

      setTimeout(() => {
        onSuccess();
      }, 5000);
    } catch (err) {}

    reset();
  };

  return (
    <div className="mb-5">
      <Container className="mt-5 shadow-sm">
        {isSuccess && <CustomToast msg={"User added successfully!"} />}
        {isError && <CustomToast err={error} msg={error.data.errorMessage} />}
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row>
            <Col md={6} xs={12}>
              <Input
                label={"First name"}
                field={"firstName"}
                register={register}
                defaultValue={user.firstName}
                errors={errors}
              />
            </Col>
            <Col md={6} xs={12}>
              <Input
                label={"Last name"}
                field={"lastName"}
                register={register}
                defaultValue={user.lastName}
                errors={errors}
              />
            </Col>
          </Row>
          <Row>
            <Col md={6} xs={12}>
              <Input
                label={"Email"}
                field={"email"}
                register={register}
                defaultValue={user.email}
                errors={errors}
              />
            </Col>
            <Col md={6} xs={12}>
              <Input
                label={"Phone"}
                field={"phone"}
                register={register}
                defaultValue={user.phone}
                errors={errors}
              />
            </Col>
            <Col sm={12} md={6}>
              <Select
                label="Role"
                field="role"
                register={register}
                options={roles.map((t) => ({ value: t, label: t }))}
                errors={errors}
              />
            </Col>
          </Row>
          <Row className="py-2">
            <Col lg={12}>
              <Button
                type="submit"
                variant="success"
                className="w-100"
                disabled={isLoading}
              >
                {isLoading ? "Saving" : "Submit"}
              </Button>
            </Col>
          </Row>
        </Form>
      </Container>
    </div>
  );
};
